import { getStorageItem, setStorageItem } from "../../utils/common-utils";
import { getIPInfo } from "./api-handler";

export const mapCurrentLocation = ({ onSuccess }) => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        onSuccess({ lat: latitude, lng: longitude, allowedLocation: true });
      },
      () => {
        const ipInfo = getStorageItem("ip-info");

        if (!ipInfo) {
          getIPInfo().then(({ data: ipInformation }) => {
            setStorageItem("ip-info", ipInfo);

            const { latitude, longitude } = ipInformation.location;
            onSuccess({
              lat: latitude,
              lng: longitude,
              allowedLocation: false,
            });
          });
        } else {
          const { latitude, longitude } = ipInfo.location;
          onSuccess({ lat: latitude, lng: longitude, allowedLocation: false });
        }
      }
    );
  }
};

export const getDefaultViewPort = ({ latitude, longitude }) => {
  return {
    ...(latitude &&
      longitude && {
        zoom: 15,
        latitude,
        longitude,
      }),
    transitionDuration: 100,
  };
};
